var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _vm.open
      ? _c("div", { staticClass: "task-info-footer" }, [
          _c("div", { staticClass: "transfer-detail-title" }, [
            _vm._v(_vm._s(_vm.$t("language.popup.transferDetails")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "transfer-status-des" }, [
            _c("div", { staticStyle: { float: "left" } }, [
              _vm._v(" " + _vm._s(_vm.$t("language.common.from")) + ":")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.itemDetail.sourceCloudType === "Shares",
                    expression: "itemDetail.sourceCloudType==='Shares'"
                  }
                ],
                staticClass: "catelog-color transfer-detail-max",
                staticStyle: { cursor: "pointer" },
                attrs: {
                  title: _vm._f("getCatalogTitle")(
                    _vm._f("getCatalogShare")(_vm.itemDetail.sourceNode)
                  )
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.toShareCatalog(_vm.itemDetail)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm._f("getCatalogShare")(_vm.itemDetail.sourceNode))
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.itemDetail.sourceCloudType !== "Shares",
                    expression: "itemDetail.sourceCloudType!=='Shares'"
                  }
                ],
                staticClass: "catelog-color transfer-detail-max ",
                staticStyle: { cursor: "pointer" },
                attrs: {
                  title: _vm._f("getCatalogTitle")(
                    _vm._f("getCatalog")(_vm.itemDetail.sourceNode)
                  )
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.toSourceCatalog(_vm.itemDetail)
                  }
                }
              },
              [_vm._v(_vm._s(_vm._f("getCatalog")(_vm.itemDetail.sourceNode)))]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "transfer-status-des" }, [
            _c("div", { staticStyle: { float: "left" } }, [
              _vm._v(" " + _vm._s(_vm.$t("language.common.to")) + ":")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "catelog-color transfer-detail-max ",
                staticStyle: { cursor: "pointer" },
                attrs: {
                  title: _vm._f("getCatalogTitle")(
                    _vm._f("getCatalog")(_vm.itemDetail.desNode)
                  )
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.toAimSourceCatalog(_vm.itemDetail)
                  }
                }
              },
              [_vm._v(_vm._s(_vm._f("getCatalog")(_vm.itemDetail.desNode)))]
            )
          ]),
          _vm._v(" "),
          _vm.itemDetail.status != 3
            ? _c("div", { staticClass: "transfer-status-des" }, [
                _vm._v(
                  "\r\n            " +
                    _vm._s(_vm.$t("language.common.result")) +
                    ": "
                ),
                _vm.itemDetail.errorList.length &&
                (_vm.itemDetail.readyTranFileCount /
                  _vm.itemDetail.totalFileCount) *
                  100 >=
                  80
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.$t("language.common.patial")))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.itemDetail.errorList.length &&
                (_vm.itemDetail.readyTranFileCount /
                  _vm.itemDetail.totalFileCount) *
                  100 <
                  80
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.$t("language.common.failure")))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.itemDetail.readyTranFileCount ==
                  _vm.itemDetail.totalFileCount && _vm.itemDetail.totalFileCount
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.$t("language.common.success")))
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.itemDetail.itemProgressInfo
            ? _c("div", { staticClass: "transfer-status-des" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("language.common.fileProcess")) +
                      ":" +
                      _vm._s(_vm.itemDetail.readyTranFileCount) +
                      "/" +
                      _vm._s(_vm.itemDetail.totalFileCount)
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "transfer-success-progress" }, [
                  _vm._v(
                    _vm._s(_vm.$t("language.common.dataProcess")) +
                      ":" +
                      _vm._s(_vm._f("formatByte")(_vm.itemDetail.readedBytes)) +
                      "/" +
                      _vm._s(_vm._f("formatByte")(_vm.itemDetail.totalBytes))
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.itemDetail.itemProgressInfo
            ? _c("div", { staticClass: "transfer-status-des" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("language.common.startTime")) +
                      ":" +
                      _vm._s(
                        _vm._f("transferForMatTime")(
                          _vm.itemDetail.taskStartTimeLong
                        )
                      )
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "transfer-success-progress" }, [
                  _vm._v(
                    _vm._s(_vm.$t("language.common.endTime")) +
                      ":" +
                      _vm._s(_vm._f("getEndTime")(_vm.itemDetail))
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.itemDetail.itemProgressInfo
            ? _c("div", { staticClass: "transfer-status-des" }, [
                _vm._v(
                  _vm._s(_vm.$t("language.common.averageRate")) +
                    ":" +
                    _vm._s(
                      _vm._f("formatByteSpeed")(
                        _vm.itemDetail.readedBytes /
                          (_vm.itemDetail.taskElaspedTimeLong / 1000)
                      )
                    )
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.itemDetail.status != 3
            ? _c(
                "div",
                {
                  staticClass: "transfer-failed-footer",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.openRetryDialog(_vm.itemDetail)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.viewFailed")))]
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ea078ff8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea078ff8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_detailed_progress/tab_unfinished_detail.vue
// module id = null
// module chunks = 